import IconCompassSolid from '@/assets/icons/font_awesome/compass-solid.svg?react';
import IconFireFlameCurvedSolid from '@/assets/icons/font_awesome/fire-flame-curved-solid.svg?react';
import IconLanguageSolid from '@/assets/icons/font_awesome/language-solid.svg?react';
import IconPaletteSolid from '@/assets/icons/font_awesome/palette-solid.svg?react';
import IconTableCellsLargeSolid from '@/assets/icons/font_awesome/table-cells-large-solid.svg?react';
import IconUserGearSolid from '@/assets/icons/font_awesome/user-gear-solid.svg?react';
import IconUserSolid from '@/assets/icons/font_awesome/user-solid.svg?react';
import { EPagesMobileTabs } from '@/enums/EPagesMobileTabs';
import { TabsContent } from '@radix-ui/react-tabs';
import { useState } from 'react';
import { LayoutPageMobileWithTabs } from '../../../layouts/LayoutPageMobileWithTabs';
import { S_BUTTON__settings_user_tab } from './S_BUTTON__settings_user_tab';
import { ENUM__settings_user_tab } from './_base/ENUM__settings_user_tab';
import { S_TAB__user_account } from './account/S_TAB_user_account';
import { TabSettingsUserCollections } from './collections/TabSettingsUserCollections';
import { TabSettingsUserGeneration } from './generation/TabSettingsUserGeneration';
import { S_TAB__regional } from './regional/S_TAB__regional';
import { TabSettingsUserUI } from './ui/TabSettingsUserUI';

export function PageSettingsUserViewsMobile() {
  //FIELDS
  const [activeTab, setActiveTab] = useState(EPagesMobileTabs.SETTINGS_NAVIGATION);

  /*
   * HTML
   */
  return (
    <LayoutPageMobileWithTabs
      tabs={[EPagesMobileTabs.SETTINGS_NAVIGATION, EPagesMobileTabs.SETTINGS_PARAMS]}
      icons={[<IconCompassSolid />, <IconUserGearSolid />]}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    >
      <TabsContent className={`bg-component mt-0 !max-h-[calc(100vh-7.5rem)] h-[calc(100vh-7.5rem)]`} value={EPagesMobileTabs.SETTINGS_NAVIGATION}>
        <div className="flex flex-col gap-4 px-2 overflow-y-auto bg-component pt-4">
          <S_BUTTON__settings_user_tab setActiveTab={setActiveTab} type={ENUM__settings_user_tab.ACCOUNT} Icon={IconUserSolid} />
          <S_BUTTON__settings_user_tab setActiveTab={setActiveTab} type={ENUM__settings_user_tab.REGIONAL} Icon={IconLanguageSolid} />
          <S_BUTTON__settings_user_tab setActiveTab={setActiveTab} type={ENUM__settings_user_tab.UI} Icon={IconPaletteSolid} />
          <S_BUTTON__settings_user_tab setActiveTab={setActiveTab} type={ENUM__settings_user_tab.GENERATION} Icon={IconFireFlameCurvedSolid} />
          <S_BUTTON__settings_user_tab setActiveTab={setActiveTab} type={ENUM__settings_user_tab.COLLECTIONS} Icon={IconTableCellsLargeSolid} />
        </div>
      </TabsContent>
      <TabsContent className={`bg-component mt-0 !max-h-[calc(100vh-7.5rem)] h-[calc(100vh-7.5rem)]`} value={EPagesMobileTabs.SETTINGS_PARAMS}>
        <S_TAB__user_account />
        <S_TAB__regional />
        <TabSettingsUserUI />
        <TabSettingsUserGeneration />
        <TabSettingsUserCollections />
      </TabsContent>
    </LayoutPageMobileWithTabs>
  );
}
